<template>
  <div class="row card borderless-card" style="box-shadow: none">
    <div class="col-12 layoutPadding-30" style="/*padding:0*/">
      <div
        class="row mb-3 mt-2"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title d-flex">
          <i class="material-icons-outlined user-font mr-2 material-icon-font"
            >people_outline</i
          >
          <div style="margin-top: auto; margin-bottom: auto">People</div>
        </div>
        <div class="d-flex">
          <button
            v-if="showTeamButton && tabSelected == 'Team' && checkIniviteTeam"
            class="newTask"
            :style="
              accountUsersCount + 1 >= usersCount
                ? 'cursor:not-allowed;color: rgb(103,103,103);border-color: rgb(103,103,103);'
                : 'cursor:pointer'
            "
            id="inviteTeamId"
            @click="inviteTeam"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
            Invite Team Member
          </button>
          <!-- <button class="newTask" @click="addPeople" v-if="tabSelected == 'Contact'">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Add Contact
          </button>-->
        </div>
        <b-popover
          target="inviteTeamId"
          triggers="hover"
          placement="bottom"
          custom-class
        >
          <div v-if="accountUsersCount + 1 >= usersCount">
            You have met the limit of users for this package to add more, contact
            <a href="mailto:founders@fiifi.co" target="_blank">founders@fiifi.co</a>
            to upgrade.
          </div>
        </b-popover>
      </div>
      <b-tabs>
        <b-tab
          title="Team"
          active-nav-item-class="border-bottom: #5445F3 0% 0% no-repeat padding-box"
          active
          @click="tabSelected = 'Team'"
        >
          <Team
            @user-success="getUsersCount"
            :count="count"
            :roles="rolesData"
          ></Team>
        </b-tab>
        <b-tab title="My Contacts" @click="tabSelected = 'Contact'">
          <Contacts></Contacts>
        </b-tab>
        <b-tab
          title="Attribution"
          @click="tabSelected = 'refer'"
          v-if="showAttributionTab"
        >
          <div class="mt-4">
            <div class="d-flex">
              <div class="attributionTitle">Referrers</div>
              <img
                src="static/img/graphInfo.svg"
                v-tooltip.top-end="
                  'Referrers are those who share internally or send you deal flow, this could be venture partners, colleagues or scouts.'
                "
                class="ml-2"
              />
            </div>
            <ReferresCard v-if="tabSelected == 'refer'"></ReferresCard>
          </div>
          <div class="mt-4">
            <div class="d-flex">
              <div class="attributionTitle">Sent Deals</div>
              <img
                src="static/img/graphInfo.svg"
                v-tooltip.top-end="
                  'This section automatically keeps track if you have sent a deal to a colleague, venture partner or any person you are working with. You can share companies from the company profile page or the diligence page.'
                "
                class="ml-2"
              />
            </div>
            <SentDealsCard v-if="tabSelected == 'refer'"></SentDealsCard>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <DialogInviteTeam
      v-model="dialogTeamData"
      @user-success="getUsersCount"
      :roles="rolesData"
    ></DialogInviteTeam>
    <DialogAddContact v-model="dialogPeopleData"></DialogAddContact>
  </div>
</template>
<script>
import ReferresCard from "../../../components/Cards/ReferresCard";
import SentDealsCard from "../../../components/Cards/SentDealsCard";
import DialogInviteTeam from "../Dialogs/DialogInviteTeam";
import DialogAddContact from "../Dialogs/DialogAddContact";
import Team from "../Pages/Team";
import { mapGetters } from "vuex";
import config from "../../../../config/settings";
import api from "../../../axios_api";
import Contacts from "../Pages/Contacts";
export default {
  computed: {
    ...mapGetters("role", ["roles", "getCurrentWorkspaceRolePermissions"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    checkIniviteTeam() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD TEAM MEMBER") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    rolesData() {
      let self = this;
      this.roles.sort((a, b) => a.name.localeCompare(b.name));
      let data = [];
      data = this.roles.filter((item) => item.name != "Owner");
      return data;
    },
    showTeamButton() {
      let featureIndex = this.feature.findIndex((item) => {
        if (item == "CREATE_USER") return item;
      });
      if (featureIndex >= 0) return true;
      else return false;
    },
    showAttributionTab() {
      if (
        this.currentWorkspace.hasOwnProperty("workspace_type") &&
        this.currentWorkspace.workspace_type == "Limited Partner"
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    ReferresCard,
    DialogInviteTeam,
    DialogAddContact,
    SentDealsCard,
    Team,
    Contacts,
  },
  data() {
    return {
      config,
      tabSelected: "Team",
      dialogTeamData: {
        isShow: false,
        isReferrer: false,
        data: {},
        isCreate: true,
      },
      dialogPeopleData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      isOwner: false,
      usersCount: 0,
      count: {},
      accountUsersCount: 0,
    };
  },
  methods: {
    addPeople() {
      this.dialogPeopleData = {
        isShow: true,
        isCreate: true,
        data: {},
      };
    },
    inviteTeam() {
      if (this.accountUsersCount + 1 >= this.usersCount) {
        return;
      } else {
        this.dialogTeamData = {
          isShow: true,
          isCreate: true,
          isReferrer: false,
          data: {},
        };
      }
    },
    getUsersCount() {
      api
        .get(
          `get/workspace/createUserPermissions/${this.$route.params.workspace_id}`
        )
        .then((data) => {
          let count = data.data.encrypt.success[0];
          this.accountUsersCount = count.accountUsersCount;
          this.usersCount = count.usersCount;
          this.count = {
            accountUsersCount: this.accountUsersCount,
            usersCount: this.usersCount,
          };
        })
        .catch((err) => {
          console.log({ err });
        });
    },
  },
  mounted() {
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | People`;
    this.getUsersCount();
    let users = this.$store.getters["team/getAllUsers"];
    let user = users.find(
      (item) =>
        item.account && item.account._id == this.$route.params.account_id
    );
  },
};
</script>
<style>
.attributionTitle {
  font-size: 16px;
  line-height: 14px;
  color: #4a4a4a;
}
</style>